export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/sy.639a0bb5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};